"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _nodeHtmlParser = require("node-html-parser");

var _excluded = ["subtype-ns", "subtype"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ELEMENT_NODE = 1;
var TEXT_NODE = 3;

var getAttributes = node => {
  var atts = node.attributes;
  return !atts.length ? typeof atts === "object" && atts : [...atts].reduce((atts, att) => {
    atts[att.name] = att.value;
    return atts;
  }, {});
};

var camelToKebabCase = str => str.replace(/[A-Z]/g, letter => "-".concat(letter.toLowerCase()));

var kebabDataSet = target => Object.keys(target).reduce((dataset, key) => {
  var newKey = camelToKebabCase(key);
  dataset[newKey] = target[key];
  return dataset;
}, {});

var getDataset = node => {
  var dataSet = node.dataset;
  if (dataSet) return kebabDataSet(dataSet);
  var atts = getAttributes(node);
  return atts && Object.keys(atts).reduce((dataset, key) => {
    var data = key.match(/(?<=data-).+/);
    if (data) dataset[data] = atts[key];
    return dataset;
  }, {});
};

var getProps = node => {
  var _getDataset = getDataset(node),
      {
    "subtype-ns": subtypeNs,
    subtype: rawSubtype
  } = _getDataset,
      dataset = _objectWithoutProperties(_getDataset, _excluded);

  var subtype = {
    subtype: subtypeNs ? "".concat(subtypeNs, ":").concat(rawSubtype) : rawSubtype
  };
  var props = dataset && Object.keys(dataset).reduce((props, key) => {
    var att = key.match(/(?<=atts-).+/);

    if (att) {
      if (!props.atts) props.atts = {};
      props.atts[att] = dataset[key];
    } else props[key] = dataset[key];

    return props;
  }, {});
  return _objectSpread(_objectSpread({}, props), subtype);
};

var getContentFrom = contentNode => {
  var content = [];

  for (var node of contentNode.childNodes) {
    if (node.nodeType === TEXT_NODE) {
      content.push(node.textContent);
      continue;
    }

    if (node.getAttribute("class") === "meta-content") continue;
    content.push(getBlock(node));
  }

  return content;
};

var blockFrom = node => {
  if (node.hasAttribute("data-atts-number")) return {};
  var metaContent = node.querySelector(":scope > .meta-content");
  return _objectSpread({
    content: getContentFrom(node) || []
  }, metaContent && {
    meta_content: getContentFrom(metaContent) || []
  });
};

var getBlock = node => {
  var props = getProps(node);
  var defaultContent = ["paragraph"].includes(props.type) && {
    content: []
  };
  return _objectSpread(_objectSpread({}, props), node.childNodes.length ? blockFrom(node) : defaultContent);
};

var browserGetBlocks = nodes => Array.from(nodes, node => getBlock(node));

var nodeJsGetBlocks = nodes => nodes.reduce((blocksList, node) => {
  if (node.nodeType !== ELEMENT_NODE) return blocksList;
  blocksList.push(getBlock(node));
  return blocksList;
}, []);

var getBlocksFrom = containerNode => typeof containerNode.children === "object" ? browserGetBlocks(containerNode.children) : nodeJsGetBlocks(containerNode.childNodes);

var parseHtml = html => typeof DOMParser === "function" ? new DOMParser().parseFromString(html, "text/html") : (0, _nodeHtmlParser.parse)(html);

function html2perf(perfHtml, sequenceId) {
  var sequencesHtml = parseHtml(perfHtml.sequencesHtml[sequenceId]);
  var sequenceElement = sequencesHtml.getElementById(sequenceId);
  var props = getDataset(sequenceElement);
  return _objectSpread(_objectSpread({}, props), {}, {
    blocks: getBlocksFrom(sequenceElement)
  });
}

var _default = html2perf;
exports.default = _default;